import { Directive, HostListener, Input, Output } from '@angular/core'
import { EventEmitter, ElementRef } from '@angular/core'

declare var jQuery: any;

@Directive ({
    selector: '[gdEmitBothValuesOnEveryChange]',
    standalone: false
})

/**
 * Use this directive if you want to compare changed field values to the previous value
 * in the field. The event emitted will contain two values; the first is the value in the
 * field prior to the change, the second is the current value.
 */
export class GdEmitBothValuesOnEveryChangeDirective {
    
    @Output() gdBothValuesChange: EventEmitter<[string, string]> = new EventEmitter<[string, string]>();
    
    priorValue: string;
    
    constructor(private element : ElementRef) {}
    
    /**
     * Listen for the focus to be place on the field and initialize the priorValue.
     * This doesn't happen in an angular-provided hook because the value isn't yet in the
     * DOM element for us to get.
     */
    @HostListener('gdFocus')
    onFocus() : void {
        let fieldName = jQuery(this.element.nativeElement).attr("gdFieldId");
        this.priorValue = jQuery("#" + fieldName).val()
    }
    
    @HostListener('gdModelChange', ['$event']) 
    onModelChange(event: string) { 
        setTimeout(() => {
            this.gdBothValuesChange.next([this.priorValue, event]);
        },0);
    }

}